import { useEffect } from 'react';
import { DecisionTreeTable } from './domain/table/decision-tree-table';
import { DecisionTree } from './domain/tree/decision-tree';
import Parameters from './ui/parameters';
import { useDecisionTreeStore } from './dal/decision-tree-store';
import BottomText from './ui/bottom-text';
import Tree from './ui/tree';
import TopPanel from './ui/top-panel';
import Table from './ui/table';

// python version: https://github.com/barisesmer/C4.5/blob/master/c45/c45.py

const DecisionTreeHome = () => {

    const csv = useDecisionTreeStore(store => store.csv);
    const setDecisionTree = useDecisionTreeStore(store => store.setDecisionTree);
    const setDecisionTreeTable = useDecisionTreeStore(store => store.setDecisionTreeTable);
    const excludedColumns = useDecisionTreeStore(store => store.excludedColumns);
    const forceBinningColumns = useDecisionTreeStore(store => store.forceBinningColumns);
    const binningByDepth = useDecisionTreeStore(store => store.binningByDepth);
    const columnsRewrittenTypes = useDecisionTreeStore(store => store.columnsRewrittenTypes);
    const binningGroupsCount = useDecisionTreeStore(store => store.binningGroupsCount);

    useEffect(() => {
        if(csv.trim() === '') {
            setDecisionTree(null);
            setDecisionTreeTable(null);
            return;
        }

        const decisionTree = new DecisionTree(
            csv,
            excludedColumns,
            forceBinningColumns,
            columnsRewrittenTypes,
            binningByDepth,
            binningGroupsCount
        ) || null;

        setDecisionTree(decisionTree);

        const decisionTreeTable = new DecisionTreeTable(
            csv,
            excludedColumns,
            forceBinningColumns,
            columnsRewrittenTypes,
            binningByDepth,
            binningGroupsCount
        ) || null;

        setDecisionTreeTable(decisionTreeTable);
    }, [
        csv,
        columnsRewrittenTypes,
        excludedColumns,
        forceBinningColumns,
        setDecisionTree,
        setDecisionTreeTable,
        binningByDepth,
        binningGroupsCount,
    ]);


    return(
        <div className="w-full py-2 overflow-auto" dir="rtl" style={ {
            maxWidth: 'calc(100vw - 200px)',
        } }>

            <TopPanel />

            <div className="flex gap-6">
                <Parameters />

                <Table />

            </div>

            <Tree />

            <BottomText />
        </div>
    )
};

export default DecisionTreeHome;
